import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { CategoriaApi, CategoriaInventaApi } from '../models/api/categoria-api';
import { ResponseApi } from '../models/response-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class CategoriaService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/categoria/';
    private cache$?: Observable<CategoriaApi[]>;

    listCategorias(): Observable<CategoriaApi[]> {
        if (!this.cache$) {
            this.cache$ = this.http.get<ResponseApi<CategoriaApi[]>>(this.url + 'list-categorias').pipe(
                map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : [])),
                shareReplay(1)
            );
        }
        return this.cache$;
    }

    listCategoriasInventa(): Observable<CategoriaInventaApi[]> {
        return this.http.get<ResponseApi<CategoriaInventaApi[]>>(this.url + 'list-categorias-inventa').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    invalidate(): void {
        this.cache$ = undefined;
    }

    activarCategoria(inventaCategoriaId: number): Observable<boolean> {
        return this.http.post<ResponseApi<unknown>>(this.url + 'activar-categoria', { inventaCategoriaId }).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }

    desactivarCategoria(inventaCategoriaId: number): Observable<boolean> {
        return this.http.post<ResponseApi<unknown>>(this.url + 'desactivar-categoria', { inventaCategoriaId }).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }

    configCategoria(body: {
        uuid?: string | null;
        inventaCategoriaId: number;
        padreUuid?: string | null;
        slug?: string;
        descripcion?: string;
        imagenUuid?: string | null;
        mostrarEnMenu: boolean;
        orden: number;
    }): Observable<boolean> {
        return this.http.post<ResponseApi<unknown>>(this.url + 'config-categoria', body).pipe(
            tap(() => this.invalidate()),
            map((res) => res.success === Constante.REQUEST_STATUS_OK)
        );
    }
}
